import { Link, useLocation } from 'react-router-dom'

/**
 * 404 Not Found Page
 * 
 * This page is shown when users navigate to a route that doesn't exist.
 * It includes the Layout wrapper (nav bar) for better UX.
 */

export default function NotFoundPage() {
  const location = useLocation()
  
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center px-4">
        <h1 className="text-8xl font-bold text-neutral-900/10">404</h1>
        <h2 className="text-2xl font-semibold text-foreground mt-4">
          Page Not Found
        </h2>
        <p className="text-muted-foreground mt-2 max-w-md mx-auto">
          The page <code className="bg-muted px-2 py-1 rounded text-sm">{location.pathname}</code> doesn't exist.
        </p>
        <div className="mt-8 space-x-4">
          <Link 
            to="/"
            className="inline-block px-8 py-3.5 text-base font-medium text-white bg-neutral-900 rounded-full hover:bg-neutral-800 transition-colors"
          >
            Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-block px-8 py-3.5 text-base border border-neutral-300 text-neutral-900 font-medium rounded-full hover:bg-neutral-100 transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  )
}
